import axios from "axios";

export const downloadDocument = async (downloadUrl, document, blobCallback) => {
  fetch(`${downloadUrl}/${document}`, { method: "GET", })
    .then(
      (res) => {
        if (res.ok && res.status === 200) {
        } else {
          return null;
        }

        return res.arrayBuffer();
      },
      (error) => {
      }
    )
    .then((buffer) => {
      blobCallback(new Uint8Array(buffer));
    });
};

export const downloadUrl = `${process.env.REACT_APP_BACKEND_URL}/api/download/document`
export const downloadUrlSettings = `${process.env.REACT_APP_BACKEND_URL}/api/download/settings/document`
export const requestDownload = `${process.env.REACT_APP_BACKEND_URL}/api/download/pdf`
